import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: 'landing',
		children: [{
			path: 'rules',
			loadChildren: () => import(/* webpackChunkName: 'landing' */ './rules/rules.module')
				.then((m) => m.RulesModule),
		}]
	},
	{
		path: '',
		children: [
			{ path: '**', redirectTo: '' }
		]
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class LandingRoutingModule {}